export default __webpack_public_path__ + "static/media/img-47-griffin.8fef1403.jpg";